import axios from 'axios';
import { present } from '@/shared/utils/typescript';
import { formatQualityControl, parseQualityControl, parseQualityControls } from '../converters/qualityControlConverters';
import { DossierId } from '../models/AbstractDossier';
import QualityControl, { QualityControlId } from '../models/QualityControl';

export default class QualityControlClient {
  static async loadAll(dossierId: DossierId): Promise<Array<QualityControl>> {
    const response = await axios.get(`/api/mobopro/v1/dossiers/${dossierId}/qualitycontrols`);
    return parseQualityControls(response.data);
  }

  static async create(dossierId: DossierId, qualityControl: QualityControl): Promise<QualityControl> {
    const response = await axios.post(`/api/mobopro/v1/dossiers/${dossierId}/qualitycontrols`, formatQualityControl(qualityControl));
    return present(parseQualityControl(response.data));
  }

  static async update(dossierId: DossierId, qualityControl: QualityControl): Promise<QualityControl> {
    const response = await axios.patch(`/api/mobopro/v1/dossiers/${dossierId}/qualitycontrols/${qualityControl.id}`, formatQualityControl(qualityControl));
    return present(parseQualityControl(response.data));
  }

  static async delete(dossierId: DossierId, qualityControlId: QualityControlId): Promise<void> {
    await axios.delete(`/api/mobopro/v1/dossiers/${dossierId}/qualitycontrols/${qualityControlId}`);
  }
}